import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import { DollarOutlined, ExperimentOutlined, GlobalOutlined, RiseOutlined, TeamOutlined } from '@ant-design/icons';
import '../../../Styles/ResearchLabs.css';

const { Paragraph, Title } = Typography;

const domains = [
  ['Domain 1 – Geohazards', 'G-SAGL uses advanced GIS techniques, space- and airborne remote sensing, and field measurements to assess landslide susceptibility, hazard, vulnerability, and risk, and to develop seismic micro-zonation maps.'],
  ['Domain 2 – Geological Applications', 'G-SAGL applies space- and airborne hyperspectral imagery and interpretation techniques for seamless lithological mapping and the demarcation and characterization of mineral zones.'],
  ['Domain 3 – Water Resource Dynamics', 'This domain evaluates the influence of components of the hydrological cycle on water-resource dynamics.'],
  ['Domain 4 – Forest Resource Assessment', 'This domain applies and develops space- and airborne remote-sensing methods for the assessment, characterization, and change detection of forest resources.'],
];

const sdgs = [
  ['No Poverty', DollarOutlined], ['Zero Hunger', TeamOutlined],
  ['Clean Water and Sanitation', ExperimentOutlined],
  ['Decent Work and Economic Growth', RiseOutlined],
  ['Life Below Water', GlobalOutlined], ['Life On Land', GlobalOutlined],
];

const ResearchDomains = () => (
  <section className="research-domains-section sdssl-research-domains-section">
    <div className="research-domains-inner">
      <Row gutter={[72, 44]} justify="space-between">
        <Col xs={24} lg={15}>
          <Title level={2} className="research-domains-title">Research Domains</Title>
          <Divider className="ncgsa-divider" />
          {domains.map(([title, description]) => (
            <article className="research-domain" key={title}>
              <Title level={4} className="research-domain-title">{title}</Title>
              <Paragraph className="research-domain-copy">{description}</Paragraph>
            </article>
          ))}
        </Col>
        <Col xs={24} lg={8}>
          <Title level={2} className="research-domains-title">Focused SDGs</Title>
          <Divider className="ncgsa-divider" />
          <ul className="sdg-focus-list">
            {sdgs.map(([label, Icon]) => (
              <li key={label}>
                <span className="sdg-focus-icon" aria-hidden="true"><Icon /></span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  </section>
);

export default ResearchDomains;
